import { cleanParams } from 'helpers/utils';
import axios from './axios';

const createLicense = values =>
  axios({
    method: 'post',
    url: '/v1/licenses',
    data: values
  });

const editLicense = values =>
  axios({
    method: 'put',
    url: `/v1/licenses/${values.license.subscription_uuid}`,
    data: {
      organization_id: values.organization_id,
      license: {
        monitoring_points: values.license.monitoring_points,
        plan: values.license.plan,
        note: values.license.note,
        expiration_date: values.license.expiration_date,
        activation_date: values.license.activation_date
      }
    }
  });

const deleteLicense = (licenseId, organizationId) =>
  axios({
    method: 'delete',
    url: `/v1/licenses/${licenseId}`,
    params: {
      organization_id: organizationId
    }
  });

const loadLicenses = organizationId =>
  axios({
    method: 'get',
    url: `/v1/licenses`,
    params: {
      organization_id: organizationId
    }
  });

const loadLicensesByResume = (licenseId, limit, page, order) =>
  axios({
    method: 'get',
    url: `/v2/organization/license/${licenseId}/transaction/history`,
    params: {
      limit,
      page,
      order
    }
  });

const renewLicense = license => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);

  return axios({
    method: 'put',
    url: `/v1/licenses/renew/${license.subscription_uuid}`,
    data: {
      license_id: license.subscription_uuid,
      organization_id: license.organization_id,
      expiration_date: date
    }
  });
};

const loadExpiredLicenses = ({
  limit, page, order, sort, expiration_date, support_name, license_plan, license_note }) => {

  const params_object = cleanParams({
    limit, page, order, sort, expiration_date, support_name, license_note
  });

  const params = new URLSearchParams(params_object);

  if (license_plan.length) license_plan.forEach(item => params.append('license_plan', item));

  return axios({
    method: 'get',
    url: '/v2/licenses/expired/paginated',
    params
  });
}


export {
  createLicense,
  editLicense,
  loadLicenses,
  loadLicensesByResume,
  renewLicense,
  deleteLicense,
  loadExpiredLicenses
};
